module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Medium.ttf
// module id = 70
// module chunks = 8